import { Box, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";

const PolicyText = styled(Box)(({ theme }) => ({
  lineHeight: "1.8",
  marginBottom: theme.spacing(2),
  textAlign: "left"
}));

const PolicySectionTitle = styled(Box)(({ theme }) => ({
  fontWeight: "bold",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
  color: "var(--red-primary)"
}));

const PolicyListItem = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1)
}));

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const buildPolicySection = (title: string, items: string[]) => (
    <>
      <PolicySectionTitle className="B-16">{title}</PolicySectionTitle>
      {items.map((item, index) => (
        <PolicyListItem key={index} className="B-14">
          • {item}
        </PolicyListItem>
      ))}
    </>
  );

  return (
    <section style={{ backgroundColor: "var(--bg-color)", minHeight: "100vh", padding: "50px 0" }}>
      <Container>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <h1 className="H-32" style={{ color: "var(--red-primary)" }}>
            BEŞİKTAŞLI TIBBİYELİLER DERNEĞİ SİTESİ GİZLİLİK POLİTİKASI
          </h1>
        </Box>

        <Box sx={{ 
          backgroundColor: "white", 
          padding: 4, 
          borderRadius: "16px", 
          boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.1)" 
        }}>
          <PolicyText className="B-14">
            <Box sx={{ textAlign: "center", mb: 2, fontStyle: "italic" }}>
              Yürürlük Tarihi: 06/10/2025<br />
              Son Güncelleme: 10/09/2026
            </Box>

            <PolicySectionTitle className="B-16">1. GİRİŞ</PolicySectionTitle>
            Bu Gizlilik Politikası, Beşiktaşlı Tıbbiyeliler ("Dernek") ve Adjuvan Sağlık ve Bilişim tarafından geliştirilen ve işletilen mobil uygulama MD Kartal ("Uygulama") ve/veya web sitesi aracılığıyla toplanan, işlenen ve saklanan kişisel verilere ilişkin esasları düzenlemektedir.<br /><br />
            Dernek olarak, kullanıcılarımızın ve üyelerimizin kişisel verilerinin gizliliğine en üst düzeyde önem veriyoruz.<br /><br />
            Kişisel verilerinizin işlenmesi sürecinde, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK"), Türk Ceza Kanunu'nun 135–140. maddeleri, Elektronik Haberleşme Kanunu, Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ve ilgili tüm ikincil mevzuat hükümlerine tam uyum göstermekteyiz.

            <PolicySectionTitle className="B-16">2. KİŞİSEL VERİLERİN TOPLANMASI VE İŞLENMESİ</PolicySectionTitle>
            Uygulamayı kullanmanız sırasında tarafımızca çeşitli kişisel verileriniz toplanabilir.<br /><br />
            Bu veriler, sizlere dernek hizmetlerini sunabilmek, üyelik işlemlerinizi yürütmek ve uygulama üzerinden etkileşim sağlayabilmek amacıyla işlenir.

            <Box component="span" sx={{ fontWeight: "bold", display: "block", mt: 1 }}>2.1. Toplanan Kişisel Veri Türleri</Box>
            Kimlik Bilgileri: Ad, soyad, T.C. kimlik numarası, doğum tarihi<br />
            İletişim Bilgileri: Telefon numarası, e-posta adresi, ikamet adresi<br />
            Üyelik ve Aidat Bilgileri: Üyelik başlangıç tarihi, aidat ödeme geçmişi, ödeme tutarları, fatura bilgileri<br />
            Finansal Veriler: Banka/ödeme altyapısı üzerinden gerçekleşen işlem bilgileri<br />
            Kullanım Verileri: Katıldığınız etkinlikler, sohbet grupları, anket yanıtları, uygulama içi gezinme geçmişi<br />
            Cihaz ve Teknik Bilgiler: IP adresi, cihaz türü, işletim sistemi, tarayıcı tipi, oturum süresi, uygulama sürümü<br />
            Görsel-İşitsel Veriler: Profil fotoğrafı, paylaşılan görseller, etkinliklerde kullanılan medya içerikleri

            <PolicySectionTitle className="B-16">3. KİŞİSEL VERİLERİN İŞLENME AMAÇLARI</PolicySectionTitle>
            Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:<br />
            Dernek üyelik kayıtlarının oluşturulması, güncellenmesi ve yönetimi<br />
            Aidat ve yıllık ödemelerin tahsil edilmesi, makbuz ve fatura işlemlerinin yürütülmesi<br />
            Dernek faaliyetleri, etkinlikler, duyurular ve bilgilendirmelerin paylaşılması<br />
            Uygulama üzerinden oluşturulan sohbet grupları ve anketlerin yönetimi<br />
            Kullanıcı taleplerinin ve şikâyetlerinin değerlendirilmesi<br />
            Yasal yükümlülüklerin ve resmi kurum taleplerinin yerine getirilmesi<br />
            Uygulamanın güvenliğinin sağlanması, dolandırıcılığın önlenmesi<br />
            Hizmet kalitesinin artırılması, kullanıcı deneyiminin geliştirilmesi<br />
            Uygulamanın teknik bakım, geliştirme ve performans analizlerinin yapılması<br />
            Dernek içi iletişimin sağlanması ve dayanışmanın güçlendirilmesi

            <PolicySectionTitle className="B-16">4. KİŞİSEL VERİLERİN İŞLENME VE AKTARIM DAYANAĞI</PolicySectionTitle>
            Kişisel verileriniz, KVKK'nın 5. ve 6. maddeleri uyarınca aşağıdaki hukuki sebeplerle işlenmektedir:<br />
            Açık rızanızın bulunması,<br />
            Kanunlarda açıkça öngörülmesi,<br />
            Dernek üyeliği ilişkisi kapsamında sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması,<br />
            Hukuki yükümlülüklerin yerine getirilmesi,<br />
            Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,<br />
            İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, dernek faaliyetlerinin yürütülmesi için veri işlemenin zorunlu olması.<br /><br />
            Verileriniz, yalnızca mevzuata uygun biçimde ve belirli amaçlarla işlenmektedir.

            <PolicySectionTitle className="B-16">5. KİŞİSEL VERİLERİN AKTARILMASI</PolicySectionTitle>
            Kişisel verileriniz aşağıdaki durumlarda üçüncü taraflarla paylaşılabilir:<br />
            Yetkili kamu kurum ve kuruluşlarıyla: Yasal bildirim veya talep halinde,<br />
            Banka ve ödeme kuruluşlarıyla: Aidat ve diğer ödeme işlemlerinin güvenli biçimde yapılması amacıyla,<br />
            Yazılım ve bulut hizmeti sağlayıcılarıyla: Uygulama altyapısının çalışması, veri yedekleme ve güvenlik amaçlarıyla,<br />
            Dernek içi birimlerle: Etkinlik organizasyonları, iletişim ve duyurular için.<br /><br />
            Kişisel verileriniz yurt dışına aktarılmamaktadır.

            <PolicySectionTitle className="B-16">6. KİŞİSEL VERİLERİN SAKLANMA SÜRESİ</PolicySectionTitle>
            Kişisel verileriniz;<br />
            Üyelik süresi boyunca,<br />
            Yasal yükümlülüklerin gerektirdiği asgari süre boyunca (örneğin, 5–10 yıl süreyle finansal kayıtların saklanması),<br />
            Veya açık rızanızın geri çekilmesine kadar<br />
            güvenli biçimde saklanır. Süre dolduğunda, verileriniz KVKK'nın 7. maddesi uyarınca silinir, yok edilir veya anonim hale getirilir.

            <PolicySectionTitle className="B-16">7. VERİ GÜVENLİĞİ</PolicySectionTitle>
            Dernek olarak, kişisel verilerinizin korunması amacıyla hem teknik hem idari tedbirleri uygulamaktayız:<br />
            Yetkisiz erişimlerin önlenmesi için kimlik doğrulama sistemleri, güvenlik duvarı ve SSL sertifikası,<br />
            Ödeme işlemlerinde 3D Secure ve şifreli bağlantı protokolleri,<br />
            Verilerin yalnızca yetkili personel tarafından erişilebilir olması,<br />
            Sunucu ve veri tabanlarında düzenli yedekleme ve antivirüs koruması,<br />
            Çalışanlarımızın KVKK bilinciyle eğitilmesi.

            <PolicySectionTitle className="B-16">8. KULLANICININ HAKLARI (KVKK MADDE 11)</PolicySectionTitle>
            KVKK'nın 11. maddesi uyarınca, kişisel verilerinizle ilgili olarak aşağıdaki haklara sahipsiniz:<br />
            Kişisel verinizin işlenip işlenmediğini öğrenme,<br />
            İşlenmişse buna ilişkin bilgi talep etme,<br />
            İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,<br />
            Verilerin aktarıldığı üçüncü kişileri bilme,<br />
            Eksik veya yanlış işlenmiş verilerin düzeltilmesini isteme,<br />
            KVKK'nın 7. maddesi uyarınca silinmesini veya yok edilmesini isteme,<br />
            İşlemin aktarıldığı üçüncü kişilere bildirilmesini talep etme,<br />
            Münhasıran otomatik sistemler aracılığıyla analiz sonucu aleyhinize bir durum oluşmasına itiraz etme,<br />
            Verilerin hukuka aykırı işlenmesi sebebiyle zarara uğramanız halinde tazminat talep etme.<br /><br />
            Bu haklarınızı kullanmak için yazılı olarak veya Beşiktaşlı Tıbbiyeliler Derneğine ait info@besiktaslitibbiyeliler.org üzerinden başvuru yapabilirsiniz.<br />
            Dernek, başvurularınızı en geç 30 gün içerisinde ücretsiz olarak sonuçlandıracaktır.

            <PolicySectionTitle className="B-16">9. ÇEREZLER (COOKIES) VE ANALİTİK VERİLER</PolicySectionTitle>
            Uygulamamızda kullanıcı deneyimini geliştirmek, performansı artırmak ve teknik hataları tespit etmek amacıyla çerezler (cookies) veya benzeri teknolojiler kullanılabilir.<br />
            Çerezler aracılığıyla elde edilen veriler hiçbir şekilde üçüncü kişilerle paylaşılmaz.

            <PolicySectionTitle className="B-16">10. POLİTİKA DEĞİŞİKLİKLERİ</PolicySectionTitle>
            Bu Gizlilik Politikası, Dernek tarafından zaman zaman güncellenebilir.<br />
            Güncel politika metni uygulama ve/veya web sitesi üzerinden erişilebilir hale getirilecektir.<br />
            Politikada yapılan değişiklikler derhal yürürlüğe girer.

            <PolicySectionTitle className="B-16">11. İLETİŞİM BİLGİLERİ</PolicySectionTitle>
            Beşiktaşlı Tıbbiyeliler<br />
            Adres: Metropol İstanbul, Atatürk, Ertuğrul Gazi Sk. No:2E A2 Blok D:452, 34758 Ataşehir/İstanbul<br />
            E-posta: info@besiktaslitibbiyeliler.org<br />
            Telefon: +90 506 199 95 12<br />
            Web Sitesi: https://besiktaslitibbiyeliler.org<br /><br />

            Beşiktaşlı Tıbbiyeliler Derneği olarak kişisel verilerinizin korunmasına en az sizin kadar önem veriyoruz.<br />
            Verileriniz bizim için bir emanet; biz de bu emaneti dürüstlük, saygı ve güven ilkeleriyle koruyoruz.
          </PolicyText>

          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button 
              variant="contained" 
              onClick={() => navigate(-1)}
              sx={{ 
                backgroundColor: "var(--red-primary)",
                "&:hover": {
                  backgroundColor: "var(--red-dark)"
                }
              }}
            >
              Geri Dön
            </Button>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default PrivacyPolicy;
